import React, { useState } from "react";

function TableContainer({
  headerGroups,
  getTableBodyProps,
  rows,
  getTableProps,
  prepareRow,
  getRowProps = () => ({}),
  totalRecords,
  tableData,
  renderExpandedRow,
  expandedRowId,
  setExpandedRowId,
}) {
  const [showAllColumns, setShowAllColumns] = useState(false);

  const toggleShowColumns = () => setShowAllColumns(!showAllColumns);

  const getRowUniqueId = (row) =>
    `${row.original.appointment_id}_${row.original.investigation_data?.investigation_id}`;

  const handleRowClick = (row) => {
    const rowProps = getRowProps(row.original) || {};
    if (typeof rowProps.onClick === "function") {
      rowProps.onClick();
    }
    if (typeof setExpandedRowId !== "function") return;

    const uniqueId = getRowUniqueId(row);
    setExpandedRowId((prev) => (prev === uniqueId ? null : uniqueId));
  };

  const totalColumns = headerGroups[0]?.headers?.length + 1;

  return (
    <>
      <div className="boxContent noPadding">
        <div className="contentScroll">
          <table className="table mb-0 table-hover" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => {
                const { key: groupKey, ...restGroupProps } =
                  headerGroup.getHeaderGroupProps();
                return (
                  <tr key={groupKey} {...restGroupProps}>
                    {headerGroup.headers
                      .filter((column, index) => {
                        const isSpecialHeader =
                          headerGroup.headers[1].Header === "Employee Name" ||
                          (headerGroup.headers[1].Header ===
                            "Investigation/Test Name" &&
                            headerGroup.headers[2].Header ===
                              "Investigation/Test Code");
                        if (showAllColumns || (isSpecialHeader && index < 5))
                          return true;
                        else if (!isSpecialHeader) return true;
                        return false;
                      })
                      .map((column) => {
                        const headerProps = column.getHeaderProps(
                          column.getSortByToggleProps(),
                        );
                        const { key: headerKey, ...restHeaderProps } =
                          headerProps;

                        return (
                          <th key={headerKey} {...restHeaderProps}>
                            {" "}
                            {column.render("Header")}
                          </th>
                        );
                      })}
                    {(headerGroup.headers[1].Header === "Employee Name" ||
                      (headerGroup.headers[1].Header ===
                        "Investigation/Test Name" &&
                        headerGroup.headers[2].Header ===
                          "Investigation/Test Code")) && (
                      <th>
                        <button
                          className="btn btn-primary"
                          onClick={toggleShowColumns}
                        >
                          {showAllColumns ? "Hide" : "View All"}
                        </button>
                      </th>
                    )}
                  </tr>
                );
              })}
            </thead>

            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);

                const isExpanded =
                  expandedRowId ===
                  `${row.original.appointment_id}_${row.original.investigation_data?.investigation_id}`;

                return (
                  <React.Fragment key={row.id}>
                    {(() => {
                      const rowProps = row.getRowProps();
                      const { key: rowKey, ...restRowProps } = rowProps;

                      return (
                        <tr
                          key={rowKey}
                          {...restRowProps}
                          onClick={() => handleRowClick(row)}
                          style={{ ...restRowProps.style, cursor: "pointer" }}
                        >
                          {row.cells
                            .filter((rowCell, index) => {
                              const isSpecialHeader =
                                headerGroups[0].headers[1].Header ===
                                  "Employee Name" ||
                                headerGroups[0].headers[1].Header ===
                                  "Investigation/Test Name";
                              if (
                                showAllColumns ||
                                (isSpecialHeader && index < 5) ||
                                rowCell.column.id === "id"
                              )
                                return true;
                              else if (!isSpecialHeader) return true;
                              return false;
                            })
                            .map((rowCell) => {
                              const cellProps = rowCell.getCellProps();
                              const { key: cellKey, ...restCellProps } =
                                cellProps;

                              return (
                                <td
                                  key={cellKey}
                                  {...restCellProps}
                                  style={{
                                    ...restCellProps.style,
                                    ...getStatusStyle(row, rowCell),
                                  }}
                                >
                                  {row.original.container_colour_code &&
                                    rowCell.column.id ===
                                      "container_colour_code" && (
                                      <div
                                        style={{
                                          backgroundColor:
                                            row.original.container_colour_code,
                                          height: "20px",
                                          width: "20px",
                                          borderRadius: "50%",
                                          margin: "auto",
                                        }}
                                      />
                                    )}

                                  {rowCell.column.id !==
                                    "container_colour_code" &&
                                    rowCell.render("Cell")}
                                </td>
                              );
                            })}
                        </tr>
                      );
                    })()}

                    {isExpanded && renderExpandedRow && (
                      <tr>
                        <td
                          colSpan={totalColumns}
                          style={{ padding: 0, background: "#f8f9fa" }}
                        >
                          <div
                            style={{
                              padding: "16px",
                              borderTop: "2px solid #dee2e6",
                              borderBottom: "2px solid #dee2e6",
                              animation: "slideDown 0.2s ease",
                            }}
                          >
                            {renderExpandedRow(row.original)}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {totalRecords === 0 && <div className="noData">No data found</div>}
      {tableData?.length === 0 && <div className="noData">No data found</div>}

      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
}

function getStatusStyle(row, rowCell) {
  if (rowCell.column.id === "container_colour_code") return { fontSize: "0px" };
  const status = row?.original?.status;
  const invStatus = row?.original?.investigation_data?.status;
  if (status === "APPROVED") return { backgroundColor: "#90EE90" };
  if (status === "PENDING") return { backgroundColor: "#fff" };
  const statusMap = {
    PENDING: "#b6dffa",
    ALL: "#f78f8f",
    APPROVED: "#90EE90",
    RESULT_DONE: "pink",
    RESULT_NOT_DONE: "white",
    SAMPLE_REJECTED: "#7AA3CC",
    MAC_DATA: "#E2680A",
    DISPATCHED: "#44A3AA",
    LAB_NOT_RECEIVED: "#FFCC99",
    "SAMPLE NOT COLLECTED": "rgb(229, 194, 255)",
    COLLECTED: "#BFD7EA",
    HOLD: "#DAA520",
    RECEIVED: "#fcaf95",
    NOT_APPROVED: "#8c98f5",
    REJECTED: "rgb(163, 193, 230)",
    REPORT_ISSUED: "#00FFFF",
  };
  return invStatus ? { backgroundColor: statusMap[invStatus] || {} } : {};
}

export default TableContainer;
